<template>
  <div class="container-fluid mt-2">
    <h2>Aussdienst-Mitarbeiter</h2>
    <b-tabs>
      <b-tab title="Allgemein">
        <iHandUserEntry @loaded="updateLogin" :userid="userid"/>
      </b-tab>
      <b-tab title="Anmeldung">
        <iHandUserLogin class="mt-3" :userid="userid" :loginid="loginid"/>
      </b-tab>
      <b-tab title="Sortimente">
          <iHandUserSelections :handid="handid"/>
      </b-tab>
      <b-tab title="Aufgaben">
        <iHandUserTasks ref="tasks" class="mt-3" :userid="userid"/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import iHandUserEntry      from '@/components/admin/ihand/iHandUserEntry.vue'
import iHandUserLogin      from '@/components/admin/ihand/iHandUserLogin.vue'
import iHandUserTasks      from '@/components/admin/ihand/iHandUserTasks.vue'
import iHandUserSelections from '@/components/admin/ihand/iHandUserSelections.vue'

export default {
  name: 'iHandUserEditor',
  components: {
    iHandUserEntry,
    iHandUserLogin,
    iHandUserTasks,
    iHandUserSelections
  },
  data() {
    return {
      userid: -1,
      loginid: '',
      handid: '',
    }
  },
  created: function() {
    this.userid = this.$route.params.userid;
  },
  methods: {
    updateLogin: function(data) {
      console.log('update: ',data);
      this.loginid = data.login;
      this.userid = data.id;
      this.handid = data.handid;
      this.$refs.tasks.updateTasks(data.handid);
    }
  }
}
</script>
